<script setup>
import { computed } from 'vue';

// Card do anúncio Click-to-WhatsApp: mostra a legenda e o criativo (clicável)
// para o consultor e o agente terem contexto de qual anúncio o lead veio.
const props = defineProps({
  referral: { type: Object, required: true },
});

const val = (...keys) => {
  for (const k of keys) {
    if (props.referral?.[k]) return props.referral[k];
  }
  return '';
};

const headline = computed(() => val('headline'));
const body = computed(() => val('body'));
const thumb = computed(() => val('thumbnail_url', 'thumbnailUrl', 'image_url', 'imageUrl'));
const link = computed(() => val('source_url', 'sourceUrl'));
const isVideo = computed(() => val('media_type', 'mediaType') === 'video');
</script>

<template>
  <component
    :is="link ? 'a' : 'div'"
    :href="link || undefined"
    :target="link ? '_blank' : undefined"
    rel="noopener noreferrer"
    class="flex gap-2 p-2 rounded-lg border border-n-weak bg-n-alpha-1 max-w-xs no-underline"
    :class="link ? 'hover:bg-n-alpha-2 cursor-pointer' : ''"
  >
    <div class="relative flex-shrink-0">
      <img
        v-if="thumb"
        :src="thumb"
        alt="Criativo do anúncio"
        class="w-12 h-12 rounded object-cover"
      />
      <div
        v-else
        class="w-12 h-12 rounded bg-n-slate-3 flex items-center justify-center"
      >
        <span class="i-lucide-megaphone text-n-slate-11 text-lg" />
      </div>
      <span
        v-if="isVideo"
        class="absolute inset-0 flex items-center justify-center"
      >
        <span class="i-lucide-play text-white text-lg drop-shadow" />
      </span>
    </div>
    <div class="min-w-0 flex flex-col justify-center">
      <div
        class="text-xs font-medium text-n-slate-11 flex items-center gap-1"
      >
        <span class="i-lucide-megaphone text-xs" />
        Veio de um anúncio
      </div>
      <div
        v-if="headline"
        class="text-sm font-medium text-n-slate-12 truncate"
      >
        {{ headline }}
      </div>
      <div v-if="body" class="text-xs text-n-slate-11 line-clamp-2">
        {{ body }}
      </div>
    </div>
  </component>
</template>
